// modules/DateTimeField.jsx
import React from "react";
import { Box, TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const DateTimeField = ({ module, value, isEditable, fieldKey, onChange }) => {
  const parsedValue = value ? dayjs(value) : null;

  return (
    <Box marginY={2}>
      <DateTimePicker
        label={module.label}
        value={parsedValue}
        onChange={(newValue) =>
          onChange(fieldKey, newValue ? newValue.toISOString() : null)
        }
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            required={module.required}
            margin="normal"
            InputLabelProps={{ shrink: true }}
            InputProps={{ readOnly: !isEditable }}
            disabled={!isEditable}
          />
        )}
        disabled={!isEditable}
      />
    </Box>
  );
};

export default DateTimeField;
